var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5003 25.2299C35.5003 24.5573 35.4407 23.9187 35.3385 23.2971H25.7173V27.1371H31.2261C30.9792 28.3973 30.2554 29.4615 29.1826 30.1853V32.7396H32.4692C34.3934 30.9601 35.5003 28.3377 35.5003 25.2299Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.717 35.2172C28.4757 35.2172 30.7831 34.2977 32.4689 32.7396L29.1824 30.1853C28.2628 30.7983 27.0964 31.1729 25.717 31.1729C23.052 31.1729 20.7957 29.3764 19.9869 26.9498H16.5981V29.5807C18.2755 32.9184 21.7238 35.2172 25.717 35.2172Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9871 26.9498C19.7742 26.3368 19.6635 25.6812 19.6635 25C19.6635 24.3189 19.7827 23.6633 19.9871 23.0502V20.4193H16.5984C15.9002 21.7986 15.5 23.3482 15.5 25C15.5 26.6518 15.9002 28.2014 16.5984 29.5807L19.9871 26.9498Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.717 18.8271C27.2241 18.8271 28.5693 19.3465 29.6336 20.3597L32.5455 17.4478C30.7831 15.796 28.4757 14.7828 25.717 14.7828C21.7238 14.7828 18.2755 17.0817 16.5981 20.4193L19.9869 23.0502C20.7957 20.6236 23.052 18.8271 25.717 18.8271Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b0ff5cb4a18a9ea5726322e12337fd14.svg";
export { ForwardRef as ReactComponent };